import React from 'react';
import cn from 'clsx';

import Image from '../../library/image/image';

import styles from './stopping-distance-chart.scss';

interface SnowStoppingDistanceChartProps {
  bottomOffset?: number;
  className?: string;
  renderTicks?: (
    value: number,
    scaleMax: number,
    scaleMin: number
  ) => React.ReactElement;
  scaleMax: number;
  scaleMin: number;
  value: number;
}

function StoppingDistanceChart(props: SnowStoppingDistanceChartProps) {
  const {
    bottomOffset = 0,
    className = '',
    renderTicks,
    scaleMax,
    scaleMin,
    value: valueProp
  } = props;
  const value = Math.min(scaleMax, valueProp);
  const carOffset = Math.floor(
    ((value - scaleMin) / (scaleMax - scaleMin)) * 100
  );
  const leftEndpointOffset = carOffset === 100 ? 25 : 16;

  return (
    <div
      className={cn(
        styles['container'],
        `stopping-distance-chart ${className}`
      )}
    >
      {renderTicks?.(value, scaleMax, scaleMin)}
      <div
        className={cn(styles['empty'], 'stopping-distance-chart__empty')}
        style={{ bottom: bottomOffset + 8 }}
      />
      <div
        className={cn(styles['fill'], 'stopping-distance-chart__fill')}
        style={{ bottom: bottomOffset + 8, width: `${carOffset}%` }}
      />
      <span
        className={styles['value-marker']}
        style={{
          bottom: bottomOffset + 6,
          left: `calc(${carOffset}% - ${leftEndpointOffset}px)`
        }}
      >
        <span className={styles['value']} style={{ bottom: bottomOffset + 21 }}>
          {value}&apos;
        </span>
        <Image
          alt="Car Image"
          className={styles['car-image']}
          src="https://discounttire.scene7.com/is/image/discounttire/ic_car?fmt=png-alpha"
        />
      </span>
    </div>
  );
}

export default StoppingDistanceChart;
